import styled from '@emotion/styled';
import { Button, StyledDiv, Typography } from '../../../../index';
import { FC } from 'react';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface LpRecordingIdleStickyFooterProps {
  onRecordStart: () => void;
  position?: 'top' | 'bottom';
}

export const LpRecordingIdleStickyFooter: FC<
  LpRecordingIdleStickyFooterProps
> = ({ onRecordStart, position = 'bottom' }) => {
  return (
    <StyledStickyContainer position={position}>
      <StyledDiv
        alignItem="center"
        justifyContent="space-between"
        width="100%"
        gap={16}
      >
        <StyledDiv flexDirection="column" gap={4}>
          <Typography variant="textTitleMedium">Start Recording</Typography>
          <Typography variant="textBodySmallOnSurfaceVariant">
            Record your session to get a Class Insight.
          </Typography>
        </StyledDiv>
        <Button
          variant="delete-filled"
          icon="radio_button_checked"
          onClick={onRecordStart}
        >
          Record
        </Button>
      </StyledDiv>
    </StyledStickyContainer>
  );
};

const StyledStickyContainer = styled.div<{ position: 'top' | 'bottom' }>`
  position: ${({ position }) => (position === 'top' ? 'sticky' : 'fixed')};
  ${({ position }) => (position === 'top' ? 'top: 0;' : 'bottom: 0;')};
  left: 0;
  right: 0;
  background-color: var(--md-sys-color-surface);
  padding: var(--rk-spacing-lg) var(--rk-spacing-xl);
  box-shadow: ${({ position }) =>
    position === 'top'
      ? '0 4px 12px rgba(0, 0, 0, 0.08)'
      : '0 -4px 12px rgba(0, 0, 0, 0.08)'};
  z-index: 2000;
  border-${({ position }) => (position === 'top' ? 'bottom' : 'top')}: 1px solid
    var(--md-sys-color-outline-variant);

  ${mq(BreakpointSizes.desktop)} {
    padding: var(--rk-spacing-xl);
  }
`;
